import { CSS_VARIABLES as p } from "./index.es15.js";

var i = function i(r) {
  if (!r) return;
  if (typeof r == "number") return "".concat(r, "px");
  var t = r.includes("%"),
      e = r.includes("px");
  return t || e || Number.isNaN(r) ? r : "".concat(r, "px");
},
    o = function o(_ref) {
  var r = _ref.element,
      t = _ref.property,
      e = _ref.value;
  e && r.style.setProperty(t, e);
},
    n = function n(_ref2) {
  var r = _ref2.offset,
      t = _ref2.element;
  o({
    element: t,
    property: p.transform,
    value: r.transform
  }), o({
    element: t,
    property: p.top,
    value: i(r.top)
  }), o({
    element: t,
    property: p.left,
    value: i(r.left)
  }), o({
    element: t,
    property: p.right,
    value: i(r.right)
  }), o({
    element: t,
    property: p.bottom,
    value: i(r.bottom)
  }), o({
    element: t,
    property: p.triangleOffset.transform,
    value: r.triangleOffset.transform
  }), o({
    element: t,
    property: p.triangleOffset.top,
    value: i(r.triangleOffset.top)
  }), o({
    element: t,
    property: p.triangleOffset.left,
    value: i(r.triangleOffset.left)
  }), o({
    element: t,
    property: p.triangleOffset.right,
    value: i(r.triangleOffset.right)
  }), o({
    element: t,
    property: p.triangleOffset.bottom,
    value: i(r.triangleOffset.bottom)
  });
};

export { n as setOffsetStyles };